export default __webpack_public_path__ + "static/char-s-sp03-ja-036cceb3f18a4837286901f240a27ef9.png";